module.exports = __webpack_public_path__ + "img/y-125.c002de69.png";